import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import { AlertTriangle, Info, CheckCircle, XCircle } from 'lucide-react';

const iconMap = {
  warning: { icon: AlertTriangle, color: 'var(--color-warning)' },
  danger: { icon: XCircle, color: 'var(--color-error)' },
  info: { icon: Info, color: 'var(--color-info)' },
  success: { icon: CheckCircle, color: 'var(--color-success)' },
};

/**
 * ConfirmDialog - Themed confirmation dialog with icon variants
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'warning',
  loading = false,
}) {
  const { icon: IconComponent, color } = iconMap[variant] || iconMap.warning;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', pb: 1 }}>
        <div
          className="mx-auto mb-3 flex items-center justify-center rounded-2xl"
          style={{
            width: 56,
            height: 56,
            backgroundColor: `${color}15`,
          }}
        >
          <IconComponent size={28} style={{ color }} />
        </div>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="body2"
          sx={{ color: 'var(--text-secondary)', textAlign: 'center' }}
        >
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{ minWidth: 100 }}
        >
          {cancelText}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          color={variant === 'danger' ? 'error' : variant === 'success' ? 'success' : 'primary'}
          sx={{ minWidth: 100 }}
        >
          {loading ? 'Processing...' : confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
